import React from 'react';
import { VStack } from 'native-base';
import { observer, GIFTCARD_FLOWS } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import { Button } from '~/shared/Theme';

const Addpayment = () => {

    return (
        <VStack space={8}>
            <Caption
                text={'credit_card.add_payment'}
                textAlign={'center'}
                fontSize={24}
            />
            <Button
                fontSize={18}
                text={'giftCard.add_cc'}
                onPress={() => observer.emit('change-screen', GIFTCARD_FLOWS.addPaymentCard)}
            />
        </VStack>
    );
};

export default Addpayment;
